import React from 'react';
import { Container } from 'react-bootstrap';
import { Trans } from 'react-i18next';

const OutsourcingAdvantages2 = props => (
    <section id="outsourcing-advantages-section2" className="my pt-5 white-bg">
        <div className='blue-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingAdvantages:section-2.title')}</h2>
            <p className='m-0'>
                <Trans i18nKey="services:outsourcingAdvantages:section-2.text"
                    components={{
                        br: <br />,
                        outsourcingPilar: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_pilar.path')} className="link" />
                    }}
                />
            </p>
        </Container>
    </section>
);

export default OutsourcingAdvantages2;
